import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBass = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	width: 24,
	height: 24,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fill: "currentColor",
			d: "M24,6.895c0,1.479-1.197,2.676-2.676,2.676s-2.676-1.197-2.676-2.676s1.197-2.677,2.676-2.677S24,5.415,24,6.895"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "currentColor",
			d: "M21.324,12.449c-1.477,0-2.676,1.201-2.676,2.678s1.201,2.675,2.676,2.675c1.476,0,2.676-1.2,2.676-2.675 C24,13.65,22.8,12.449,21.324,12.449z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "currentColor",
			d: "M9.358,1.182C7.337,0.391,5.139,0.441,3.325,1.32c-1.423,0.693-2.473,1.83-3,3.227C0.117,5.006,0,5.514,0,6.053 c0,2.033,1.654,3.688,3.688,3.688c2.035,0,3.689-1.655,3.689-3.688c0-1.423-0.813-2.66-1.998-3.273 C6.411,2.57,7.538,2.67,8.609,3.09c3.148,1.234,4.321,4.413,4.368,6.977c0.082,4.455-3.229,9.897-8.914,11.295 c-0.548,0.135-0.883,0.688-0.75,1.238c0.115,0.467,0.532,0.777,0.993,0.777c0.081,0,0.163-0.009,0.246-0.027 c6.081-1.496,10.583-7.224,10.471-13.32c-0.076-4.113-2.248-7.504-5.668-8.844L9.358,1.182z"
		})
	]
});
export default SvgBass;
